module.exports = __webpack_public_path__ + "img/Dangling-Award1.jpg";